import { ApiService, toModels } from '~/shared/api'
import { UniversityFilterBlockModel, UniversitySortOptionModel } from '~/models/universities'
import { API_PREFIX } from '~/shared/const/request-services'

export class UniversitiesFiltersService extends ApiService {
  readonly urls = {
    sortVariables: `${API_PREFIX}/universities/sort-variables`,
    filterFields: `${API_PREFIX}/universities/filter-fields`,
  }

  getSortVariables(): Promise<UniversitySortOptionModel[]> {
    return this.http
      .request({ url: this.urls.sortVariables })
      .then(toModels(UniversitySortOptionModel))
  }

  getFilterFields(): Promise<UniversityFilterBlockModel[]> {
    return this.http
      .request({ url: this.urls.filterFields })
      .then(toModels(UniversityFilterBlockModel))
  }
}
